import { useState, useEffect } from "react";
import { FormControl, FormHelperText, Typography } from "@mui/material";
// import { makeStyles } from '@mui/styles';
import { makeStyles } from "@mui/styles";
// import { makeStyles } from 'tss-react/mui';
import { Controller } from "react-hook-form";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Select, { components } from "react-select";
import classes from "./SelectMultipleWidgetFilter.module.scss";
// import { IsDesktopHandler } from '../../../helpers';
import errorMessage from "../../common/errorMessages.json";
// import theme from 'theme';

import theme from "../../theme";
import { IsDesktopHandler } from "../../helpers";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: 0,
    minWidth: 180,
    width: "100%",
    maxWidth: "100%",
    fontSize: 14,
    // fontFamily: theme.typography,
    color: theme.palette.text.primary,
    // [theme.breakpoints.down('sm')]: {
    //   minWidth: '95%',
    // },
  },
  errorStateStyle: {
    "& .react-select__control": {
      borderColor: theme.palette.error.main,
    },
  },
  rootLabel: {
    fontSize: 14,
    paddingLeft: 5,
    paddingRight: 5,
    color: theme.palette.primary.main,
    fontWeight: 500,
    // backgroundColor: "white",
    marginBottom: "8px",
  },
  inputContainerStyleVertical: (props) => ({
    minHeight: props.minheight ? 65 : "auto",
    ...props.containerStyle,
    "& label": {
      fontSize: "18px",
      paddingLeft: 15,
      paddingRight: 15,
      color: "#4C5662 !important",
      top: "-3px",
    },
    "& fieldset": {
      "& legend": {
        fontSize: "15px",
      },
    },
    "& .react-select__value-container": {
      padding: ` ${props.sizeSelect === "large" ? "10px 10px" : "5px 10px"}`,
      // paddingTop: "2.5px",
    },
    "& .react-select__indicators > div": {
      padding: "0px 10px",
    },
    "& .react-select__indicators > span": {
      marginBottom: "4px",
      marginTop: "4px",
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
    },
  }),
}));

// console.log(theme, '<-----------theme');

const customVerticalStyles = {
  container: () => ({
    width: "100%",
  }),
  control: (styles) => ({
    // none of react-select's styles are passed to <Control />
    ...styles,
    paddingTop: 0,
    borderRadius: theme.shape.borderRadius,
    borderColor: theme.palette.primary.light,
    minHeight: 34,
    backgroundColor: "none",
    "&:hover": {
      borderColor: theme.palette.primary.main,
    },
    "&.react-select__control--is-focused": {
      borderColor: theme.palette.primary.main,
      boxShadow: "0 0 0 1px " + theme.palette.primary.main,
    },
  }),
  ValueContainer: (styles, { data }) => ({
    ...styles,
    // backgroundColor: "tomato",
    paddingTop: 0,
  }),
  // menu: () => ({
  // 	width: '100%',
  // 	backgroundColor: '#f8f8f8',
  // 	maxHeight: '300px',
  // 	overflowY: 'scroll',
  // }),
  // menuList: () => ({
  // 	display: 'flex',
  // 	flexWrap: 'wrap',
  // 	width: '100%',
  // 	backgroundColor: 'white',
  // }),
  placeholder: (styles) => ({
    ...styles,
    ...theme.typography.body2,
    fontWeight: 600,
  }),
  option: (provided, state) => ({
    ...provided,
    // borderBottom: '.4px solid rgba(223,223,223,.5)',
    // borderRight: '.4px solid rgba(223,223,223,.5)',
    // width: '200px',
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.white,
    },
    backgroundColor: state.isSelected ? theme.palette.primary.main : "white",
    fontSize: theme.typography.fontSize,
    color: state.isSelected ? theme.palette.white : theme.palette.text.primary,
  }),
  singleValue: (styles, { data }) => ({
    ...styles,
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    fontWeight: 600,
  }),
  multiValue: (styles, { data }) => ({
    ...styles,
    backgroundColor: "#cccccc",
    borderRadius: "4px",
    paddingLeft: "4px",
    marginTop: "3px",
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    padding: "1px 2px",
    paddingRight: "8px",
    fontSize: 13,
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    // backgroundColor: 'blue',
    borderTopRightRadius: "4px",
    borderBottomRightRadius: "4px",
    ":hover": {
      backgroundColor: "#cccccc",
      color: "white",
    },
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const SelectMultipleWidgetFilter = (props) => {
  const {
    errors,
    req,
    loading,
    control,
    name,
    options,
    defaultValue,
    placeholder,
    display = "vertical",
    variant = "standard",
    isMulti = true,
    style,
    onlyOptionValue = false,
    minheight = true,
    containerStyle,
    sizeSelect = null,
    ...others
  } = props;

  // const classesUI = useStyles();

  // console.log(errors, '<-----------errors');

  const classesUI = useStyles();
  const [stateMessage, setStateMessage] = useState("");
  const [stateError, setStateError] = useState(false);

  let validate = null;
  useEffect(() => {
    if (errors) {
      switch (errors.type) {
        case "required":
          // Verificar si el campo existe en errorMessage antes de acceder
          const fieldError = errorMessage.message[name];
          if (fieldError) {
            setStateMessage(
              fieldError.required ? fieldError.required : fieldError
            );
          } else {
            // Mensaje genérico para campos no definidos en errorMessages.json
            setStateMessage("Este campo es requerido");
          }
          break;
        default:
          break;
      }
      setStateError(true);
    } else {
      setStateMessage("");
      setStateError(false);
    }
  }, [errors, name]);

  let labelText = props.labeltext ? props.labeltext : null;
  const isDesktop = IsDesktopHandler("sm");
  // if (!isDesktop) {
  //   labelText = props.labeltext;
  // } else {
  //   labelText = null;
  // }

  // if (display === "vertical") {
  //   labelText = props.labeltext;
  // }

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <ArrowDropDownIcon />
      </components.DropdownIndicator>
    );
  };

  // para aplicar o no el minheight al campo
  const CustomInputContainer = (props) => {
    const classesUI = useStyles(props);
    return (
      <div className={clsx(classesUI.inputContainerStyleVertical)}>
        {props.children}
      </div>
    );
  };

  return (
    <CustomInputContainer
      minheight={minheight}
      sizeSelect={sizeSelect}
      containerStyle={containerStyle}
    >
      {props.loading && display !== "vertical" && <p>cargando</p>}
      <FormControl
        className={classesUI.formControl}
        error={stateError}
        variant="standard"
        style={style || {}}
      >
        {labelText ? (
          <Typography
            id={labelText}
            className={classesUI.rootLabel}
            // variant="h6"
          >
            {props.labeltext}{" "}
            {/* {loading && (
              <p
                style={{
                  marginTop: "2px",
                }}
              >
                ...cargando
              </p>
            )} */}
          </Typography>
        ) : null}
        <Controller
          render={({ field }) => {
            return (
              <Select
                options={options}
                isMulti={isMulti}
                variant={variant}
                labelId={labelText}
                error={stateError}
                {...field}
                isLoading={loading}
                menuPortalTarget={document.body}
                {...others}
                classNamePrefix="react-select"
                className={stateError ? classesUI.errorStateStyle : ""}
                components={{
                  DropdownIndicator,
                }}
                noOptionsMessage={() => "No hay resultados"}
                placeholder={placeholder}
                styles={customVerticalStyles}
              />
            );
          }}
          name={name}
          rules={{
            required: req,
            validate: validate,
          }}
          control={control}
          defaultValue={defaultValue}
        />

        {stateError && (
          <FormHelperText className={classes.errorText} error>
            {stateMessage}
          </FormHelperText>
        )}
      </FormControl>
    </CustomInputContainer>
  );
};

export default SelectMultipleWidgetFilter;
